module.exports = __webpack_public_path__ + "img/mGoogle.19a26ff.svg";